"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALID_UNITS = ['second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year', 'seconds', 'minutes', 'hours', 'days', 'weeks', 'months', 'quarters', 'years'];